import { render, staticRenderFns } from "./VideoJSPlayer.vue?vue&type=template&id=6db85932"
import script from "./VideoJSPlayer.vue?vue&type=script&lang=js"
export * from "./VideoJSPlayer.vue?vue&type=script&lang=js"
import style0 from "./VideoJSPlayer.vue?vue&type=style&index=0&id=6db85932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports